/* All accessories rows view (sections/pb-accessory-rows.liquid, PB-1191).
   Rows mode: All tab, no tag in the path, no filter or sort in the query. Otherwise the product grid shows.
   Each row fetches its products through the Section Rendering API (sections/pb-accessory-row).
   Rows load as they come near the screen (IntersectionObserver), with two fallbacks so a fast scroll never leaves an
   empty row: a scroll check of every row's position (each frame while scrolling and every 1.5 s), and a background pass
   after load that fills the rows within four screens. */
(function () {
  'use strict';
  var D = document;
  var root = D.querySelector('[data-pbar]');
  if (!root || root._pbarOn) return;
  root._pbarOn = true;
  var base = (root.getAttribute('data-base') || '').replace(/\/$/, '');
  var LIMIT = parseInt(root.getAttribute('data-limit'), 10) || 12;
  var rows = Array.prototype.slice.call(root.querySelectorAll('[data-pbar-row]'));
  var MAXQ = 3, active = 0, queue = [], leadP = null, tagP = {};

  /* ---------- mode follows the URL (the hero tabs and sidebar filters re-render the grid in place) ---------- */
  var STATIC = root.hasAttribute('data-static');
  function rowsMode() {
    if (STATIC) return true;
    var p = location.pathname.replace(/\/$/, '');
    if (p !== base) return false;
    var s = new URLSearchParams(location.search), on = true;
    s.forEach(function (v, k) { if (k.indexOf('filter.') === 0 || k === 'sort_by' || k === 'q') on = false; });
    return on;
  }
  function applyMode() {
    var m = rowsMode() ? 'rows' : 'grid';
    if (root.getAttribute('data-mode') !== m) root.setAttribute('data-mode', m);
    if (m === 'rows') kick();
  }
  window.addEventListener('popstate', function () { setTimeout(applyMode, 0); });
  function watchGrid() {
    var pc = D.getElementById('ProductGridContainer');
    if (!pc || !window.MutationObserver) return;
    var t;
    new MutationObserver(function () { clearTimeout(t); t = setTimeout(applyMode, 30); }).observe(pc, { childList: true });
  }
  /* a tab click pushes the new URL before the grid renders: follow it at once */
  D.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('.pbch2__tab, .pbch2__chip, .pb-theme-links a')) setTimeout(applyMode, 0);
  });

  /* ---------- counts and the Show more card ---------- */
  function more(n) {
    if (n >= 1000) return Math.floor(n / 100) * 100 + '+';
    if (n >= 100) return Math.floor(n / 100) * 100 + '+';
    if (n >= 20) return Math.floor(n / 10) * 10 + '+';
    return '+' + n;
  }
  function setCount(row, n) {
    row._n = n;
    var c = row.querySelector('[data-pbar-count]'); if (c) c.textContent = n ? String(n) : '';
    var shown = row.querySelectorAll('[data-pbar-track] > .pbar__card:not(.pbar__sk)').length;
    var rest = n - shown, noun = row.getAttribute('data-noun') || '';
    var mn = row.querySelector('[data-pbar-mn]'), mt = row.querySelector('[data-pbar-mt]'), mb = row.querySelector('[data-pbar-mb]');
    if (rest > 0) { mn.textContent = more(rest); mt.textContent = 'more ' + noun; }
    else { mn.textContent = ''; mt.textContent = n === 1 ? 'Just this one for now' : 'That is all ' + n; }
    mb.textContent = n === 1 ? 'View' : 'Show all ' + n;
    row.classList.toggle('is-all', rest <= 0);
    row.hidden = n === 0;
    groups();
  }
  function groups() {
    root.querySelectorAll('[data-pbar-group]').forEach(function (g) {
      var any = g.querySelector('[data-pbar-row]:not([hidden])');
      g.hidden = !any;
    });
  }

  /* ---------- card photos: lazy images that land on screen through a jump or a fast scroll were never requested
     (live bug: 45 in view, 0 loaded). Rows near the screen load their first photos eagerly instead. ---------- */
  var EAGER = 8;
  function eager(row, upto) {
    var cards = row.querySelectorAll('[data-pbar-track] > .pbar__card[data-pid]'), n = Math.min(cards.length, upto || EAGER);
    for (var i = 0; i < n; i++) {
      var imgs = cards[i].querySelectorAll('img[loading="lazy"]');
      for (var j = 0; j < imgs.length; j++) { imgs[j].setAttribute('fetchpriority', 'low'); imgs[j].loading = 'eager'; }
    }
  }
  function near(row, screens) {
    if (!row.offsetParent && !row.getClientRects().length) return false;
    var b = row.getBoundingClientRect(), h = window.innerHeight || vh0;
    return b.top < h * (1 + screens) && b.bottom > -h * screens;
  }

  /* ---------- loading ---------- */
  function srcFor(row, attr) {
    var s = row.getAttribute(attr || 'data-src');
    if (!s) return '';
    s += (s.indexOf('?') === -1 ? '?' : '&') + 'section_id=pb-accessory-row';
    if (row._sort && row._sort !== 'best-selling') s += '&sort_by=' + encodeURIComponent(row._sort);
    return s;
  }
  function ids(el) { return Array.prototype.map.call(el.querySelectorAll('.pbar__card[data-pid]'), function (c) { return c.getAttribute('data-pid'); }).join(','); }
  function want(row, force) {
    if (!force && (row._state === 'done' || row._state === 'wait' || row._state === 'busy')) return;
    row._state = 'wait';
    queue.push(row); pump();
  }
  function pump() {
    while (active < MAXQ && queue.length) run(queue.shift());
  }
  function run(row, tries) {
    tries = tries || 0;
    active++; row._state = 'busy'; row.classList.add('is-busy');
    var err = row.querySelector('[data-pbar-err]'); if (err) err.hidden = true;
    var token = row._token = (row._token || 0) + 1;
    function get(u) {
      if (!u) return Promise.resolve(null);
      /* a stalled request must not hold a queue slot: give up after 15 s and let the retry take over */
      var ac = window.AbortController ? new AbortController() : null, to = ac ? setTimeout(function () { ac.abort(); }, 15000) : 0;
      return fetch(u, { credentials: 'same-origin', signal: ac ? ac.signal : undefined }).then(function (r) { clearTimeout(to); if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
        .then(function (html) { var res = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-pbar-res]'); if (!res) throw new Error('no rows markup'); return res; });
    }
    /* the row in its sort; its mystery items (tag acc-mystery) always lead the row (Brandon M-5FE4).
       All mystery items come from one shared fetch, matched to the row by its tab tag or product type. */
    if (!leadP) {
      var lu = root.getAttribute('data-lead');
      leadP = lu ? get(lu + '?section_id=pb-accessory-row').catch(function () { return null; }) : Promise.resolve(null);
    }
    /* a row's own lead tag (e.g. acc-lead-keychains): those products follow the mystery items, in any sort */
    var lt = row.getAttribute('data-lead-tag') || '', ltP = null;
    if (lt) {
      if (!tagP[lt]) tagP[lt] = get((root.getAttribute('data-base') || '') + '/' + lt + '?section_id=pb-accessory-row').catch(function () { return null; });
      ltP = tagP[lt];
    }
    Promise.all([get(srcFor(row)), leadP, ltP])
      .then(function (both) {
        if (token !== row._token) return;
        var res = both[0], all = both[1], tagged = both[2];
        var n = parseInt(res.getAttribute('data-count'), 10) || 0;
        var rtag = row.getAttribute('data-tag') || '', rtypes = (row.getAttribute('data-types') || '').split(',').map(function (t) { return t.trim(); }).filter(Boolean);
        var first = all && rtag !== 'acc-mystery' ? Array.prototype.filter.call(all.children, function (c) {
          return (rtag && (c.getAttribute('data-tags') || '').indexOf('|' + rtag + '|') !== -1) || (!rtag && rtypes.indexOf(c.getAttribute('data-type')) !== -1);
        }) : [];
        if (tagged && tagged.children.length) first = first.concat(Array.prototype.slice.call(tagged.children));
        if (first.length) {
          /* lead cards come from the shared mystery fetch: give them this row's own ids so no id appears twice on the page */
          var rk = 'pbar-lead-' + rows.indexOf(row);
          var lead = [], seen = {};
          first.forEach(function (c) {
            var pid = c.getAttribute('data-pid'); if (seen[pid]) return; seen[pid] = 1;
            var t = D.createElement('div'); var h = c.outerHTML.split('pbar-acc-mystery').join(rk); if (lt) h = h.split('pbar-' + lt).join(rk + 't'); t.innerHTML = h; lead.push(t.firstElementChild);
          });
          lead.forEach(function (c) { seen[c.getAttribute('data-pid')] = 1; });
          var rest = Array.prototype.slice.call(res.children).filter(function (c) { return !seen[c.getAttribute('data-pid')]; });
          while (res.firstChild) res.removeChild(res.firstChild);
          lead.concat(rest).slice(0, LIMIT).forEach(function (c) { res.appendChild(c); });
        }
        var track = row.querySelector('[data-pbar-track]'), moreEl = track.querySelector('[data-pbar-more]');
        var fresh = ids(res), had = ids(track);
        if (fresh !== had || track.querySelector('.pbar__sk')) {
          /* keep cards that are already on the page (their image sliders may be running) and only add, move or drop
             the difference; dropping a running card mid-start is what threw "[splide] null is invalid" */
          var keep = {};
          Array.prototype.forEach.call(track.querySelectorAll('.pbar__card[data-pid]'), function (c) { keep[c.getAttribute('data-pid')] = c; });
          var want = {};
          Array.prototype.forEach.call(res.children, function (c) { want[c.getAttribute('data-pid')] = 1; });
          Array.prototype.slice.call(track.querySelectorAll('.pbar__card')).forEach(function (c) { if (!c.hasAttribute('data-pid') || !want[c.getAttribute('data-pid')]) c.remove(); });
          var cur = track.querySelector('.pbar__card') || moreEl;
          Array.prototype.slice.call(res.children).forEach(function (c) {
            var pid = c.getAttribute('data-pid');
            var el = keep[pid] && keep[pid].parentNode ? keep[pid] : D.importNode(c, true);
            if (el === cur) { cur = cur.nextElementSibling || moreEl; return; }
            track.insertBefore(el, cur);
          });
          if (row._sorted) track.scrollLeft = 0;
        }
        row._sorted = false;
        row._state = 'done';
        if (near(row, 1.5)) eager(row);
        /* remember a filled row's height for the rows still waiting (placeholders match it) */
        var th = row.querySelector('[data-pbar-track]').offsetHeight; if (th > 100 && !root._th) { root._th = th; root.style.setProperty('--pbar-track-h', th + 'px'); }
        setCount(row, n);
        arrows(row);
      })
      .catch(function () {
        if (token !== row._token) return;
        if (tries < 1) { active--; setTimeout(function () { run(row, tries + 1); }, 1200); return true; }
        row._state = 'fail';
        if (err) err.hidden = false;
      })
      .then(function (retrying) {
        if (retrying === true) return;
        row.classList.remove('is-busy');
        active--; pump();
      });
  }

  /* 1) near the screen */
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting && root.getAttribute('data-mode') === 'rows') { want(e.target); if (e.target._state === 'done') eager(e.target); } });
  }, { rootMargin: '900px 0px 900px 0px' }) : null;
  /* 2) a scroll check: anything above the fold line plus a screen and a half is wanted now (catches fast flicks) */
  var vh0 = window.innerHeight || 800, ticking = false;
  function sweep() {
    ticking = false;
    if (root.getAttribute('data-mode') !== 'rows') return;
    var lim = vh0 * 2.5;
    for (var i = 0; i < rows.length; i++) {
      var r = rows[i];
      if (r._state === 'done') { if (near(r, 1.5)) eager(r); continue; }
      if (r._state === 'busy' || r._state === 'wait') continue;
      if (!r.offsetParent && !r.getClientRects().length) continue;
      var b = r.getBoundingClientRect();
      if (b.top < lim && b.bottom > -lim) want(r);
    }
  }
  function onScroll() { if (!ticking) { ticking = true; (window.requestAnimationFrame || setTimeout)(sweep); } }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('scrollend', function () { sweep(); }, { passive: true });
  /* the header Accessories tab eases the page down to these rows: start every row (and its first photos) now, not on arrival */
  if (STATIC) D.addEventListener('click', function (e) {
    if (!e.target.closest || !e.target.closest('[data-pbt-tab="acc"], a[href$="#accessorise"], a[href*="__accessorise-rows"]')) return;
    rows.forEach(function (r) { if (!r.classList.contains('is-hidden')) want(r); });
  }, true);
  setInterval(sweep, 1500);
  /* 3) after load, fill the rows within the next few screens in the background (cards are heavy, so not every row) */
  function backfill() {
    if (root.getAttribute('data-mode') !== 'rows') return;
    var lim = vh0 * 4;
    rows.forEach(function (r) { if ((!r._state || r._state === 'fail') && r.getBoundingClientRect().top < lim) want(r); });
  }

  var kicked = false;
  function kick() {
    if (kicked) { sweep(); return; }
    kicked = true;
    rows.forEach(function (r) {
      var c = parseInt(r.getAttribute('data-n'), 10);
      if (r.hasAttribute('data-filled') && !isNaN(c)) setCount(r, c);
      if (io) io.observe(r);
    });
    sweep();
    var later = function () { setTimeout(backfill, 1200); };
    if (D.readyState === 'complete') later(); else window.addEventListener('load', later, { once: true });
  }

  /* ---------- per-row sort ---------- */
  root.addEventListener('change', function (e) {
    var sel = e.target.closest('[data-pbar-sort]'); if (!sel) return;
    var row = sel.closest('[data-pbar-row]'); if (!row) return;
    row._sort = sel.value; row._sorted = true;
    /* Show all keeps the row's sort */
    row.querySelectorAll('[data-pbar-all], [data-pbar-more]').forEach(function (a) {
      if (!a._href) a._href = a.getAttribute('href');
      var h = a._href;
      if (sel.value && sel.value !== 'best-selling') h += (h.indexOf('?') === -1 ? '?' : '&') + 'sort_by=' + encodeURIComponent(sel.value);
      a.setAttribute('href', h);
    });
    want(row, true);
  });
  root.addEventListener('click', function (e) {
    /* homepage tabs: one category inline as a grid, or every row */
    var tb = e.target.closest('[data-pbar-tab]');
    if (tb) {
      var key = tb.getAttribute('data-pbar-tab');
      root.querySelectorAll('[data-pbar-tab]').forEach(function (x) { var on = x === tb; x.classList.toggle('is-on', on); x.setAttribute('aria-selected', String(on)); });
      root.classList.toggle('is-only', !!key);
      rows.forEach(function (r) { var on = !!key && r.getAttribute('data-key') === key; r.classList.toggle('is-on', on); if (on) want(r); });
      if (key) { var r0 = root.querySelector('[data-pbar-row].is-on'); if (r0 && r0.getBoundingClientRect().top < 0) r0.scrollIntoView({ block: 'start' }); }
      sweep();
      return;
    }
    var rt = e.target.closest('[data-pbar-retry]');
    if (rt) { var row = rt.closest('[data-pbar-row]'); if (row) want(row, true); return; }
    var pv = e.target.closest('[data-pbar-prev], [data-pbar-next]');
    if (pv) {
      var tr = pv.closest('[data-pbar-row]').querySelector('[data-pbar-track]');
      var step = Math.max(200, tr.clientWidth * 0.8) * (pv.hasAttribute('data-pbar-prev') ? -1 : 1);
      tr.scrollBy({ left: step, behavior: 'smooth' });
    }
  });

  /* ---------- arrows show where there is more to scroll ---------- */
  function arrows(row) {
    var tr = row.querySelector('[data-pbar-track]');
    var p = row.querySelector('[data-pbar-prev]'), n = row.querySelector('[data-pbar-next]');
    if (!tr) return;
    row.classList.toggle('is-scrolled', tr.scrollLeft > 4);
    if (tr.scrollLeft > 4 && row._state === 'done') { var cw = (tr.querySelector('.pbar__card') || {}).offsetWidth || 200; eager(row, Math.ceil((tr.scrollLeft + tr.clientWidth) / cw) + 4); }
    if (!p || !n) return;
    p.disabled = tr.scrollLeft < 8;
    n.disabled = tr.scrollLeft + tr.clientWidth > tr.scrollWidth - 8;
  }
  rows.forEach(function (row) {
    var tr = row.querySelector('[data-pbar-track]'), t = false;
    if (tr) tr.addEventListener('scroll', function () { if (!t) { t = true; (window.requestAnimationFrame || setTimeout)(function () { t = false; arrows(row); }); } }, { passive: true });
  });
  /* width changes only (the iPhone toolbar changes height mid-scroll; ignore that) */
  var w0 = window.innerWidth;
  window.addEventListener('resize', function () {
    if (window.innerWidth === w0) return;
    w0 = window.innerWidth; vh0 = window.innerHeight || vh0;
    rows.forEach(arrows);
  });

  watchGrid();
  applyMode();
  if (root.getAttribute('data-mode') === 'rows') kick();
})();
